var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"bottom-nav md:hidden",attrs:{"aria-label":"Mobile navigation"}},_vm._l((_vm.visibleItems),function(item){return _c('router-link',{key:item.to,staticClass:"nav-item",attrs:{"to":item.to,"active-class":"is-active"}},[_c('span',{staticClass:"nav-icon"},[_c('i',{class:item.icon})]),_c('span',[_vm._v(_vm._s(item.name))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }